import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CalAngularService, ICvxClaimsPrincipal } from '@cvx/cal-angular';
import { LFDAPIService } from './core/services/api';
import { MsGraphService } from './core/services/ms-graph';
import { catchError, lastValueFrom, Observable, of, Subject, takeUntil, timer } from 'rxjs';
import { Event, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { NavigationLocation, NextPageRoute, NextPageService, PageLayout, SearchType, SliderType } from '@cvx/nextpage';
import { SessionStorageService } from './core/services/session_storage';
import { NzModalService } from 'ng-zorro-antd/modal';
import { DataService } from './core/services/data_service';
import { UserDetail, keyvalue } from './core/interfaces/User';
import { Constants, Menu, NavigationConstants } from './constants/constants';
import { environment } from 'src/environments/environment';
import { BreadcrumbService } from './core/services/breadcrumb.service';
import { AppRoutingModule } from './app-routing.module';
import { UserService } from './core/services/user.service';
import { User } from './core/models/user';
import { ApplicationRole } from './core/models/ApplicationRole';
import { NzMessageService } from 'ng-zorro-antd/message';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  standalone: false
})
export class AppComponent {
  NavigationLocation = NavigationLocation;
  PageLayout = PageLayout;
  SearchType = SearchType;
  SliderType = SliderType;
  isCollapsed = true;
  currentYear = new Date().getFullYear();
  userName: string = '';
  userphoto!: any;
  displayPhoto = false;
  role_id!: number;
  currentUserProfile!: ICvxClaimsPrincipal;
  request_id: string | undefined;
  visible = false;
  isAuthorizedUser = false;
  isInvalidUser = false;
  userData: any;
  keyvaluelist: keyvalue[] = [];
  breadcrumbs: Array<{ label: string; url?: string }> = [];
  currentUser: User = new User();
  // Session time out
  private sessionTimeoutInSeconds = 30; // Session timeout duration in seconds
  private userActivity$ = new Subject<void>();
  private timer$: any;
  private destroy$ = new Subject<void>();
  userExists: boolean = true;
  dataLoaded: boolean = true;

  constructor(
    private authService: CalAngularService,
    // private msgraph: MsGraphService,
    // private sanitizer: DomSanitizer, 
    // private apiService: LFDAPIService, 
    // private router: Router,
    // private modal: NzModalService, 
    private messaService: NzMessageService,
    private session: SessionStorageService,
    private dataService: DataService,
    private breadcrumbService: BreadcrumbService,
    private userService: UserService) {

    
    this.startTimer();
    this.initUserActivityTracking();
    this.handleSessionTimeout();

  }

  private startTimer(): void {
    //this.timer$ = timer(0, 3600000)

    this.timer$ = timer(0, 600000)
      .pipe(
        takeUntil(this.destroy$)
      );
  }
  private initUserActivityTracking(): void {
    window.addEventListener('mousemove', () => this.resetTimer());
    window.addEventListener('keydown', () => this.resetTimer());
  }

  private resetTimer(): void {
    this.userActivity$.next();
  }

  private handleSessionTimeout(): void {
    this.timer$.subscribe((seconds: number) => {
      //alert("handleSessionTimeout" + seconds);
      const remainingTime = this.sessionTimeoutInSeconds - seconds;
      if (remainingTime <= 0) {
        this.logout();
      }
    });
  }

  private logout(): void {
    this.dataService.getAccessToken();
    location.reload();
    
    // this.router.navigate(['/login']);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

  }
  async ngOnInit() {
    
    let scopes = environment.scopes;
    this.authService.getAADToken(scopes).subscribe(result => {
      const token = JSON.parse(JSON.stringify(result));
      this.session.setItem(Constants.TOKEN_KEY, token);      
      this.setTokenExpired(token);
      this.getUserInfo();
    });
    this.breadcrumbService.breadcrumbs.subscribe((breadcrumbs) => {
      this.breadcrumbs = breadcrumbs;
    });
    
  }
  private setTokenExpired(token: any) {
    try {       
      const payload = JSON.parse(atob(token.split('.')[1])); // Decode the payload
      this.session.setItem(Constants.TOKEN_EXPIRATION_KEY, payload.exp);    
      
    } catch (error) {
      console.error('Failed to decode token or extract expiration time', error);
      
    }
  }

  getUserInfo() {
    this.userService.getUserInfo().subscribe({
      next: (data: any) => {
        if (data) {
          this.currentUser = data.user;
          this.currentUser.IsRFCAdmin = this.currentUser.ApplicationRoles?.indexOf(ApplicationRole.RFCAdmin) !== -1;
          this.userService.setUserData(this.currentUser);
          this.userService.setCurrentUser(this.currentUser);
                
          this.userExists = true;
          this.dataLoaded = true;
        } else {
          //this.msgText = "User does not have access to application, please contact site administrator.";
          this.userExists = false;
          
        }
      },
      error: (error) => {
        if (error.status == 0 || error?.statusText == "Unknown Error") {
          this.messaService.error("Unable to connect to server. Please check your network connection and try again.", { nzDuration: 7000 });
        }
        console.log(error);
      }
    });
  }

  
}
